import React from 'react';
import BackIcon from '@/assets/img/back-icon.svg';
import './BackNavigation.scss';
import { useTranslation } from 'react-i18next';
export type BackNavProps = {
  onClick: () => void;
  hideText?: boolean;
};

export const BackNav = ({ onClick, hideText = false }: BackNavProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="back-nav" onClick={onClick}>
        <img src={BackIcon} alt="back icon" />
        {!hideText && <span>{t('Back')}</span>}
      </div>
    </div>
  );
};
